import { render, staticRenderFns } from "./PageAuth.vue?vue&type=template&id=460050c3&scoped=true"
import script from "./PageAuth.vue?vue&type=script&lang=js"
export * from "./PageAuth.vue?vue&type=script&lang=js"
import style0 from "./PageAuth.vue?vue&type=style&index=0&id=460050c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460050c3",
  null
  
)

export default component.exports